import * as UI from "@iyk/ui"
import * as SheetPrimitive from "@radix-ui/react-dialog"
import * as React from "react"

const SheetRoot = SheetPrimitive.Root

const SheetTrigger = SheetPrimitive.Trigger

const SheetClose = SheetPrimitive.Close

const SheetPortal = SheetPrimitive.Portal

const SheetOverlay = () => (
  <SheetPrimitive.Overlay className="fixed inset-0 z-50 bg-[rgba(24,24,24,0.8)] data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0" />
)

const sheetContentClasses = UI.cx([
  "fixed max-w-[var(--app-max-width)] mx-auto z-50 gap-4 bg-background shadow-lg transition ease-in-out text-foreground",
  "data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:duration-300 data-[state=open]:duration-500",
  "inset-x-0 bottom-0 data-[state=closed]:slide-out-to-bottom data-[state=open]:slide-in-from-bottom"
])

const SheetContent = ({
  children,
  title,
  description,
  showCloseButton = true,
  ...props
}: Sheet.ContentProps) => (
  <SheetPortal>
    <SheetOverlay />
    <SheetPrimitive.Content
      className={sheetContentClasses}
      onOpenAutoFocus={(e) => e.preventDefault()}
      {...props}
    >
      <div className="sr-only">
        <SheetPrimitive.Title>{title}</SheetPrimitive.Title>
        {description && <SheetPrimitive.Description>{description}</SheetPrimitive.Description>}
      </div>
      {children}
      {showCloseButton && (
        <SheetPrimitive.Close className="p-2.5 absolute right-0 top-0 rounded-px opacity-70 transition-opacity hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:pointer-events-none">
          <UI.Icon.Cross />
          <span className="sr-only">Cerrar</span>
        </SheetPrimitive.Close>
      )}
    </SheetPrimitive.Content>
  </SheetPortal>
)

namespace Sheet {
  export type ContentProps = {
    title: string
    description?: string
    children: React.ReactNode
    showCloseButton?: boolean
  } & SheetPrimitive.DialogContentProps
}

export const Sheet = {
  Root: SheetRoot,
  Close: SheetClose,
  Content: SheetContent,
  Overlay: SheetOverlay,
  Portal: SheetPortal,
  Trigger: SheetTrigger
}
